import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '../../../../../apis';

export function useResizeOptionsQuery(instanceId: number, enabled: boolean) {
    const { data, isPending, isError } = useQuery({
        queryKey: ['api.v1.instances.resize-options', instanceId],
        queryFn: () => Endpoints.v1.Instances.getResizeOptions(instanceId),
        enabled: enabled && instanceId > 0,
        staleTime: 0,
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    });

    return { data, isPending, isError };
}
